const AdBanner = () => null;

export default AdBanner;